export const welcome = {
  path: '/layout/welcome',
  name: 'welcome',
  component: () => import('@/views/welcome/index.vue'),
  meta: {
    title: '欢迎页',
    hidden: 1,
  },
};
